import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, OTO_LINK } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const AllLinks = () => {
	const columns = useMemo(
		() => [
			{
				Header: 'id',
				accessor: 'id',
				filterType: FilterType.number,
				show: false
			},
			{
				field: 'linkURL',
				Header: 'linkURL',
				accessor: 'linkURL',
				filterType: FilterType.string,
				renderCell: ListComponents.URL,
				showOnMobile: true,
				width: 200
			},
			{
				field: 'productName',
				Header: 'productName',
				accessor: 'productNames',
				filterType: FilterType.string
			},
			{
				field: 'weight',
				Header: 'weight',
				accessor: 'totalWeight',
				filterType: FilterType.float,
				width: 70
			},
			{
				field: 'linkUsage',
				Header: 'linkUsage',
				accessor: 'linkUsage',
				filterType: FilterType.number,
				width: 70
			},
			{
				field: 'status',
				Header: 'status',
				accessor: 'status',
				renderCell: ListComponents.STATUS,
				width: 100,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ACTIVE_INACTIVE,
				showOnMobile: true
			},
			{
				field: 'total',
				Header: 'total',
				accessor: 'subTotal',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY,
				showOnMobile: true,
				width: 100
			},
			{
				field: 'expiryDate',
				Header: 'expiryDate',
				accessor: 'linkExpiryDate',
				filterType: FilterType.date,
				renderCell: ListComponents.EXPIRY_DATE,
				showOnMobile: true,
				width: 100
			}
		],
		[]
	);

	return (
		<DynamicList
			id={DYNAMICLISTS.OTOLINK_ALL}
			columns={columns}
			fetchUrl={OTO_LINK.GET_ALL_OTO_LINKS}
			defaultSort={[{ id: 'id', desc: true }]}
			actionObjectType={ACTION_OBJECT_TYPES.OTHER}
			showColumnCalculation={false}
			// noRecordsFound={<OTOLinkOnboardingButton />}
		/>
	);
};

export default AllLinks;
